export default {
  SET_MARITAL_STATUSES: 'SET_MARITAL_STATUSES'
};